module.exports = __webpack_public_path__ + "static/media/googleplay_icon@2x.449cb19c.png";